import { useEffect, useState, useCallback } from 'react';
import { WMSInput } from '../../widgets/input';
import { DateRangePicker } from 'react-date-range';
import { Button } from 'react-bootstrap';
import { apiUrl } from '../../base/utils';
import { invokeGetService } from '../../service';
import { connect } from 'react-redux';
import NofoundLoader from '../../widgets/nofound';
import moment from 'moment';
import WHSLoader from '../../widgets/loader';
import { useLocation } from 'react-router';
import { Range } from 'react-date-range';
import ReactPaginate from 'react-paginate';
import HOCAutoLogout from '../autologout';
// import './notificationstyle.scss';

const formatDate = (date: Date): string => {
  const options: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "2-digit",
    year: "numeric",
  };
  return date.toLocaleDateString("en-US", options);
};

interface DateRange {
  startDate: Date;
  endDate: Date;
  key: string;
}

interface NotificationProps {
  isToken: string;
  userInfo: any;
}

function Notification(props: NotificationProps) {
  const [dateShow, setDateShow] = useState(false);
  const [notificationList, setNotificationList] = useState<any>({});
  const [dateRange, setDateRange] = useState<DateRange[]>([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ]);
  const [inputDate, setInputDate] = useState('');
  const [articleId, setArticleId] = useState('');
  const [isLoader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const notificationsPerPage = 10;
  const location = useLocation();

  useEffect(() => {
    getNotification('viewall');
  }, []);

  // Debounced search function that accepts the search term as parameter
  const debounceSearch = useCallback(
    debounce((searchTerm: string) => {
      if (searchTerm.trim()) {
        getNotificationWithArticleId('articleFilter', searchTerm);
      } else {
        if (inputDate) {
          getNotification('filter');
        } else {
          getNotification('viewall');
        }
      }
    }, 500),
    [props.isToken, props.userInfo, inputDate, dateRange]
  );

 const handleArticleIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const value = e.target.value;
  setArticleId(value);
  setCurrentPage(0);
  debounceSearch(value);
};

const selectionDatePicker = (ranges: any) => {
  const range: any = ranges.selection as Range;
  setDateRange([range]);
  const formattedStartDate = formatDate(range.startDate!);
  const formattedEndDate = formatDate(range.endDate!);
  setInputDate(`${formattedStartDate} to ${formattedEndDate}`);
};

const getNotificationWithArticleId = async (type: string, searchArticleId: string) => {
  let url;
  if (
    props.userInfo.roles.filter((list: any) => list.roleid == 1).length > 0
  ) {
    url = apiUrl.nodeApi.getNotification;
  } else if(props.userInfo.roles.filter((list: any) => list.roleid == 2).length > 0){
    url = apiUrl.nodeApi.getNotification;
  }else{
    url = apiUrl.nodeApi.getReviewerNotification;
  }
  setLoader(true);

  try {
    setCurrentPage(0);

    let queryParams;
    if (inputDate) {
      const startDate = moment(dateRange[0].startDate).format("YYYY-MM-DD");
      const endDate = moment(dateRange[0].endDate).format("YYYY-MM-DD");
      queryParams = {
        startDate,
        endDate,
        articleId: searchArticleId.trim()
      };
    } else {
      queryParams = {
        startDate: '',
        endDate: '',
        articleId: searchArticleId.trim()
      };
    }
    
    const response: any = await invokeGetService(url, {}, queryParams, props.isToken);
    if (response?.data?.data?.result?.data && Object.keys(response.data.data.result.data).length) {
      setNotificationList(response.data.data.result.data);
    } else {
      setNotificationList({});
    }
  } catch (error) {
    console.error('Error fetching notifications:', error);
    setNotificationList({});
  } finally {
    setLoader(false);
  }
};

const getNotification = async (type: string) => {
 
  let url;
  if (
    props.userInfo.roles.filter((list: any) => list.roleid == 1).length > 0
  ) {
    url = apiUrl.nodeApi.getNotification;
  } else if(props.userInfo.roles.filter((list: any) => list.roleid == 2).length > 0){
    url = apiUrl.nodeApi.getNotification;
  }else{
    url = apiUrl.nodeApi.getReviewerNotification;
  }
  setLoader(true);

  try {
    if (type === 'filter') {
      setDateShow(!dateShow);
      setCurrentPage(0);
      const startDate = moment(dateRange[0].startDate).format("YYYY-MM-DD");
      const endDate = moment(dateRange[0].endDate).format("YYYY-MM-DD");
      const queryParams = { 
        startDate, 
        endDate,
        articleId: articleId.trim()
      };
      const response: any = await invokeGetService(url, {}, queryParams, props.isToken);
      if (response?.data?.data?.result?.data && Object.keys(response.data.data.result.data).length) {
        setNotificationList(response.data.data.result.data);
      } else {
        setNotificationList({});
      }
    } else if (type === "viewall") {
      setCurrentPage(0);
      const queryParams = { 
        startDate: '', 
        endDate: '', 
        isViewAll: true,
        articleId: ''
      };
      const response: any = await invokeGetService(url, {}, queryParams, props.isToken);
      if (response?.data?.data?.result?.data && Object.keys(response.data.data.result.data).length) {
        setNotificationList(response.data.data.result.data);
      } else {
        setNotificationList({});
      }
    } else if (type === 'articleFilter') {
      setCurrentPage(0);
      const queryParams = {
        startDate: '',
        endDate: '',
        articleId: articleId.trim()
      };
      const response: any = await invokeGetService(url, {}, queryParams, props.isToken);
      if (response?.data?.data?.result?.data && Object.keys(response.data.data.result.data).length) {
        setNotificationList(response.data.data.result.data);
      } else {
        setNotificationList({});
      }
    } else {
      setCurrentPage(0);
      const queryParams = {
        articleId: articleId.trim()
      };
      const response: any = await invokeGetService(url, {}, queryParams, props.isToken);
      if (response?.data?.data?.result && Object.keys(response.data.data.result).length) {
        setNotificationList(response.data.data.result);
      } else {
        setNotificationList({});
      }
    }
  } catch (error) {
    console.error('Error fetching notifications:', error);
    setNotificationList({});
  } finally {
    setLoader(false);
  }
};

const handleArticleIdFilter = () => {
  if (articleId.trim()) {
    getNotification('articleFilter');
  }
};

const clearFilters = () => {
  setArticleId('');
  setInputDate('');
  setDateRange([{
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  }]);
  setCurrentPage(0);
  getNotification('viewall');
};

const handlePageClick = (data: any) => {
  setCurrentPage(data.selected);
};

const paginatedNotifications = () => {
  if (!notificationList || typeof notificationList !== 'object' || Object.keys(notificationList).length === 0) {
    return [];
  }

  const allNotifications = Object.keys(notificationList).reduce((acc: any, key: any) => {
    if (Array.isArray(notificationList[key])) {
      return [...acc, ...notificationList[key]];
    } else {
      if (notificationList[key] && typeof notificationList[key] === 'object') {
        return [...acc, notificationList[key]];
      }
      console.warn(`Skipping non-iterable value for key ${key}:`, notificationList[key]);
      return acc;
    }
  }, []);

  const sortedNotifications = allNotifications.sort((a: any, b: any) => {
    const dateA = new Date(a.updateddate || a.notificationdate || 0).getTime();
    const dateB = new Date(b.updateddate || b.notificationdate || 0).getTime();
    return dateB - dateA;
  });

  const startIndex = currentPage * notificationsPerPage;
  const endIndex = startIndex + notificationsPerPage;
  return sortedNotifications.slice(startIndex, endIndex);
};

const getTotalNotificationCount = () => {
  if (!notificationList || typeof notificationList !== 'object') {
    return 0;
  }

  return Object.keys(notificationList).reduce((acc, key) => {
    if (Array.isArray(notificationList[key])) {
      return acc + notificationList[key].length;
    } else if (notificationList[key] && typeof notificationList[key] === 'object') {
      return acc + 1;
    }
    return acc;
  }, 0);
};

const pageCount = Math.ceil(getTotalNotificationCount() / notificationsPerPage);

return (
  <div>
    {isLoader && <WHSLoader />}
    <div className="page-title">
      <h3>Notification</h3>
      <div className="dashboard-top-filter">
        <div className="row align-items-center">
          <div className="col-auto">
          <label style={{ 
              marginBottom: 20, 
              fontWeight: 'bold', 
              fontSize: '20px',
              lineHeight: '1.5'
            }}>Filter by:</label>
          </div>
          
          {/* Date Range Filter */}
          <div className="col-auto">
            <div className="datePicker-in" style={{ position: 'relative', minWidth: '240px' }}>
              <WMSInput
                type='text'
                placeHolder="Select date range"
                className='form-control bg-white'
                value={inputDate}
                onClick={() => setDateShow(!dateShow)}
                id='search-table'
              />
              <span className="material-icons" style={{ 
                position: 'absolute', 
                right: '10px', 
                top: '50%', 
                transform: 'translateY(-50%)',
                pointerEvents: 'none'
              }}>
                event
              </span>
            </div>
          </div>

          {/* Article ID Filter */}
          <div className="col-auto">
            <div style={{ position: 'relative', minWidth: '140px' }}>
              <WMSInput
                type='text'
                placeHolder="Enter Article ID"
                className='form-control'
                value={articleId}
                onChange={handleArticleIdChange}
                id='article-id-filter'
              />
            </div>
          </div>

          {/* Filter Buttons */}
          <div className="col-auto">
            <div className="d-flex" style={{ gap: '8px' }}>
              {/* <Button 
                className="btn btn-primary btn-sm" 
                onClick={handleArticleIdFilter}
                disabled={!articleId.trim()}
                style={{ whiteSpace: 'nowrap', fontSize: '12px', padding: '4px 8px' }}
              >
                Filter by Article ID
              </Button> */}
              <Button 
                className="btn btn-secondary btn-sm" 
                onClick={clearFilters}
                style={{ whiteSpace: 'nowrap', fontSize: '12px', padding: '4px 8px' }}
              >
                Clear Filter
              </Button>
            </div>
          </div>
        </div>

        {/* Date Range Picker */}
        {dateShow &&
          <div className="dateRanger-picker" style={{ 
            position: 'absolute', 
            zIndex: 1000, 
            marginTop: '10px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            backgroundColor: 'white',
            border: '1px solid #ddd',
            borderRadius: '4px'
          }}>
            <DateRangePicker
              ranges={dateRange}
              maxDate={new Date()}
              onChange={(item) => selectionDatePicker(item)}
            />
            <div className='date-footer' style={{ padding: '10px', borderTop: '1px solid #eee' }}>
              <Button className="btn btn-primary btn-sm" style={{ marginRight: '8px' }} onClick={() => getNotification('filter')}>
                APPLY
              </Button>
              <Button className="btn btn-outline-secondary btn-sm" onClick={() => setDateShow(!dateShow)}>
                CANCEL
              </Button>
            </div>
          </div>
        }
      </div>
    </div>
    
    <div className='mb-5'>
      {getTotalNotificationCount() > 0 ? (
        <>
          {paginatedNotifications().map((list: any, index: any) => (
            <div key={index} className='notification-group'>
              {index == 0 ? (
                <p>{list.formatted_date}</p>
              ) : null
              }

              <div className='notification-list'>
                <div className={`notification-list-inner ${!list.isnotified ? 'non-reader' : ""}`}>
                  <div className='notification-icon'>
                    <span className="material-icons" style={{ 
                      fontSize: '24px', 
                      color: !list.isnotified ? '#007bff' : '#6c757d' 
                    }}>
                      notifications
                    </span>
                  </div>
                  <div className='notification-details'>
                    <p>{list.status_description}</p>
                    <span>
                      {moment(new Date().toISOString()).diff(moment(list.notificationdate), 'hours') < 24
                        ? moment(new Date()).diff(moment(list.notificationdate), 'hours') < 1
                          ? moment(new Date()).diff(moment(list.notificationdate), 'minutes') + ' m ago'
                          : moment(new Date()).diff(moment(list.notificationdate), 'hours') + ' h ago'
                        : moment(new Date().toISOString()).diff(moment(list.notificationdate), 'days') + ' day ago'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {pageCount > 1 && (
            <div className='d-flex mt-3' style={{ justifyContent: "end" }}>
              <ReactPaginate
                previousLabel={
                  <span className="material-icons action-arrow-icon">
                    chevron_left
                  </span>
                }
                nextLabel={
                  <span className="material-icons action-arrow-icon">
                    chevron_right
                  </span>
                }
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={pageCount}
                marginPagesDisplayed={1}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"notificationPagination"}
                activeClassName={"active"}
                forcePage={currentPage}
              />
            </div>
          )}
        </>
      ) : <NofoundLoader />}
    </div>
  </div>
);
}

// Debounce utility function
function debounce(func: Function, delay: number) {
let timeoutId: NodeJS.Timeout;
return (...args: any[]) => {
  clearTimeout(timeoutId);
  timeoutId = setTimeout(() => func.apply(null, args), delay);
};
}

const mapStateToProps = (state: any) => {
return {
  isLogged: state.rootReducer.authReducer.isLoggedIn,
  isToken: state.rootReducer.authReducer.token,
  userInfo: state.rootReducer.authReducer.userInfo
};
};

export default connect(mapStateToProps, null)(HOCAutoLogout(Notification));